import { journalsServiceApi } from "../../api";

export const JournalsStatuses = {
  NEW: "Новый",
  IN_PROGRESS: "В процессе",
  DONE: "Завершен",
} as const;

export const TitleJournalStatuses = {
  NEW: "Новый",
  AT_SIGNING: "На подписи",
  SIGNED: "Подписан",
  REJECTED: "Отклонен",
  UNDER_APPROVAL: "На одобрение",
  SENT_TO_GSN: "Отправлен в ГСН",
} as const;

export type JournalsStatusesType = keyof typeof JournalsStatuses;
export type TitleJournalStatusesType = keyof typeof TitleJournalStatuses;

export type GetDraftJournalsRequest = {
  buildingObjectId: string;
  page?: number;
  limit?: number;
};

export interface TitleJournal {
  titleId: string;
  mainJournalNumber: string;
  noVersionId: string;
  noVersionIdHistoryId: string;
  status: TitleJournalStatusesType;
}

export interface SectionInfo {
  sectionId?: string;
  sectionListId?: string;
  rejected?: number | null;
  awaiting?: number | null;
  sent?: number | null;
  signed?: number | null;
  new?: number | null;
  received?: number | null;
}

export interface CommentsList {
  received?: number | null;
  processed?: number | null;
}

export interface BuildingInfoSummary {
  docDate?: string | null;
  docNumber?: string | null;
}

export interface RegistrationInfoSummary {
  titleVersionId?: string | null;
  versionNumber?: number | null;
  buildingInfo?: BuildingInfoSummary | null;
}

export interface MainJournal {
  mainJournalId: string;
  status: JournalsStatusesType;
  createDate: string;
  updateDate: string;
  titleJournal: TitleJournal;
  commentsList?: CommentsList;
  registrationInfo?: RegistrationInfoSummary | null;
  section1?: SectionInfo;
  section2?: SectionInfo;
  section3?: SectionInfo;
  section4?: SectionInfo;
  section5?: SectionInfo;
  section6?: SectionInfo;
}

export interface BuildingObject {
  buildingObjectId: string;
  projectId: string;
  shortName: string;
  fullName: string;
  descriptionProjects: string;
  descriptionStage: string;
  constructionType: string;
  buildingStart: string;
  buildingEnd: string;
  gsnIntegrationSettings?: {
    gsnIntegrationSettingId?: string;
    isEnabled?: boolean;
  };
  address: {
    addressId: string;
    addressType: string;
    addressString: string;
    countryId: number;
    regionId: number;
    districtName: string;
    districtCode: string;
  };
  mainJournals: MainJournal[];
}

export interface GetDraftJournalsResponse {
  total: number;
  page: number;
  limit: number;
  buildingObject: BuildingObject;
}

export const getDraftJournals = ({
  buildingObjectId,
  page = 1,
  limit = 20,
}: GetDraftJournalsRequest): Promise<GetDraftJournalsResponse> => {
  return journalsServiceApi
    .get<GetDraftJournalsResponse>("journals/main/no_version", {
      params: { buildingObjectId, page, limit },
    })
    .then((response) => response.data);
};
